/*
 * PatientOverviewPage Messages
 *
 * This contains all the text for the PatientOverviewPage container.
 */

import { defineMessages } from "react-intl";

export const scope = "app.containers.PatientOverviewPage";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "Patients",
  },
});
